import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import { Table, TableBody, TableCell, TableContainer,
        TableHead, TableRow, Paper, Typography } from '@material-ui/core';
import AlertRow from "./AlertRow";
import useStyles from "./styles";
import t from "../../../languages/pl";

const initialData = {
    alert: [
        {
            rejestracja: "",
            czas: 0,
            zdarzenie: ""
        }
    ]
};

const AlertsTable = props => {
    const classes = useStyles();
    const [rows, setRows] = useState(initialData);
    const {data} = props;

    useEffect(() => {
        setRows(data);
    }, [data]);

    const tableRows = () => {
        if(rows.alert != null){
            let rowsToDisplay = rows.alert.slice(0, 4);
            return rowsToDisplay.map(row => {
                return <AlertRow key={row.rejestracja} car={row.rejestracja} date={row.czas} event={row.zdarzenie} />;
            });
        }
    };

    return (
        <Paper className={classes.container} square>
            <Typography variant="subtitle2" className={classes.title}>
                {t.alerts}
            </Typography>
            <TableContainer>
                <Table className={classes.table} aria-label="alertsTable">
                    <TableHead>
                        <TableRow className={classes.tableRow}>
                            <TableCell className={classes.tableHeader}>{t.car}</TableCell>
                            <TableCell className={classes.tableHeader}>{t.date}</TableCell>
                            <TableCell className={classes.tableHeader}>{t.incident}</TableCell>
                            <TableCell align="center" className={classes.tableHeader}>{t.details}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {tableRows()}
                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>

    );
};

export default AlertsTable;

AlertsTable.propTypes = {
    data: PropTypes.oneOfType([PropTypes.array, PropTypes.object])
};